import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TesteService {

  public ppub_numero: string;
  public ppub_processo: string;
  public ppub_sei: string;
  public ppub_data: string;
  public ppub_horario: string;
  public ppub_modalidade: string;
  public ppub_agrupamento: string;
  public ppub_titulo: string;
  public ppub_descricao: string;
  public ppub_suspensa: string;
  public ppub_noar: string;
  public ppub_datanoar: string;
  
  public pub_inscricao: any;
  public pub_cpf: string;
  public pub_area: string;
  public pub_curso: string;
  public pub_status: string;
  public pub_arq: string;
  public pubdoc: string;
  public pubtip: string;
  public pubtipaux: string;
  public pub_nome;
  public pub_nasc;
  public pub_ope;
  public pub_sei;
  public m_id: number;

  constructor(private http: HttpClient) { }


  listar() {
    return this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoes`).toPromise();
  }

  listarPorArea() {

    //let teste = this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoesPorArea?area=${this.pub_area}`).toPromise();
   // let teste =  this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoes`).toPromise();
   console.log('cursos *************************==>',this.pub_curso);
   let teste =  this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoesPorCurso?curso=${this.pub_curso}`).toPromise();   console.log('Areas ****==>',teste);
    return teste;

  }

  listarPorCurso(curso: string) {

    let teste = this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoesPorCurso?curso=${this.pub_curso}`).toPromise();
    console.log('cursos ****==>',teste);
    return teste;

  }



  listaDocumento(doc: string) {



    if (doc == '1'){
       this.pub_arq=this.pub_cpf+'IDE.PDF';
       return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
    }

    if (doc == '2'){
      this.pub_arq=this.pub_cpf+'CPF.PDF';
      return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
   }

   if (doc == '3'){
    this.pub_arq=this.pub_cpf+'PIS.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
 }

   if (doc == '4'){
     this.pub_arq=this.pub_cpf+'RES.PDF';
     return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '5'){
    this.pub_arq=this.pub_cpf+'MIL.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
 }

 if (doc == '6'){
  this.pub_arq=this.pub_cpf+'REG.PDF';
  return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
}

if (doc == '7'){
  this.pub_arq=this.pub_cpf+'TCR.PDF';
  return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
}

   if (doc == '8'){
     this.pub_arq=this.pub_cpf+'HIS.PDF';
     return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '9'){
    this.pub_arq=this.pub_cpf+'EXP.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '50'){
    this.pub_arq=this.pub_cpf+'DIP.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '51'){
    this.pub_arq=this.pub_cpf+'INS.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '52'){
    this.pub_arq=this.pub_cpf+'ELE.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '53'){
    this.pub_arq=this.pub_cpf+'CTP.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

  if (doc == '54'){
    this.pub_arq=this.pub_cpf+'SEG.PDF';
    return this.http.get<any>(`${environment.bancoUpload}/ConsultaDocumento?cpf=${this.pub_arq}`).toPromise();
  }

}



listaEdital() {
  return this.http.get<any>(`${environment.bancoEdital}/ListaEditais`).toPromise();
  /// return this.http.get<any>(`http://incanet/PortalAdministrativo/SGHI.PaModSISAApi/Api/v1/Inscricao/ConsultaInscrito?cpf=${this.pub_cpf}`).toPromise();
   //return null;
 }


 
 listaEditalGeral() {
  return this.http.get<any>(`${environment.bancoEdital}/ListaEditaisGeral`).toPromise();
  /// return this.http.get<any>(`http://incanet/PortalAdministrativo/SGHI.PaModSISAApi/Api/v1/Inscricao/ConsultaInscrito?cpf=${this.pub_cpf}`).toPromise();
   //return null;
 }


  listaInscricao() {
   // return this.http.get<any>(`${environment.bancoInscrito}/ConsultaInscrito?cpf=${this.pub_cpf}`).toPromise();
    return this.http.get<any>(`http://incanet/PortalAdministrativo/SGHI.PaModSISAApi/Api/v1/Inscricao/ConsultaInscrito?cpf=${this.pub_cpf}`).toPromise();
    //return null;
  }

  criar(data: any) {

    const headers = new HttpHeaders().set('Content-type', 'application/json; charset=UTF-8');

    return this.http.get<any>(`${environment.bancoInscrito}/ListaInscricoes`, { headers });
  }

  verificaGestor(cpf: string) {

    // variável da url
    const url = `${environment.bancoGestor}/ConsultaGestor?cpf=${cpf}`
    // consulta a API
    console.log(url);

    return this.http.get<any>(url);
  }

  InserirArquivo(cpf: string, tipo: string, nomearquivo: string) {
    const params = new HttpParams();
    params.append('cpf', cpf);
    params.append('tipo', tipo);
    params.append('nomearquivo', nomearquivo);


    //determina novo id para o documento

    // const url = `${environment.bancoUpload}/ConsultaNextId`
    // consulta a API
    //this.m_id = this.http.get<any>(url);


    // variável da url
    const url2 = `${environment.bancoUpload}/IncluirArquivo?cpf=${cpf}&tipo=${tipo}&arquivo=${nomearquivo}`
    console.log(url2);

    // consulta a API
    return this.http.post<any>(url2, {});


  }


  verificaEndereco(cep: string) {

    // variável da url
    const url = `${environment.bancoEndereco}/BuscarCep?cep=${cep}`
    console.log(url);

    // consulta a API
    return this.http.get<any>(url);
  }



  cargaComboCursos(parameters?: string) {
    const params = new HttpParams();
    params.append('matricula', parameters);
    return this.http.get<any>(`${environment.bancoCurso}/ListaCursos`, { params: params });
  }

  cargaComboInstituicoes(parameters?: string) {
    const params = new HttpParams();
    params.append('matricula', parameters);
    return this.http.get<any>(`${environment.bancoInstituicao}/ListaInstituicoes`, { params: params });
  }

  cargaComboConselhos(parameters?: string) {
    const params = new HttpParams();
    params.append('matricula', parameters);
    return this.http.get<any>(`${environment.bancoConselho}/ListaConselhos`, { params: params });
  }

  cargaComboUfs(parameters?: string) {
    const params = new HttpParams();
    params.append('sigla', parameters);
    return this.http.get<any>(`${environment.bancoUf}/ListaUfs`, { params: params });
  }

  incluirInscricao(data: any) {

    console.log('GRAVAÇÃO');
    console.log('MODIFICACAO  ',data);
    return this.http.post<any>(`${environment.bancoInscrito}/Salvar`, data).subscribe(resposta => console.log('upload realizado'));
  }

  incluirEdital(data: any) {


    console.log('MODIFICACAO  ',data);

    const data1 =
    {

      "numero": data.numero,
      "agrupamento": data.agrupamento,
      "modalidade": data.modalidade,
      "titulo": data.titulo,
      "descricao": data.descricao,
      "data": data.data,
      "suspensa": data.suspensa,
      "noar": data.noar,
      "datanoar": data.data,
      "processo": data.processo,
      "horario": data.horario,
      "sei": data.sei,
      "id": 0

    };

    return this.http.post<any>(`${environment.bancoEdital}/Salvar`, data1).subscribe(resposta => console.log('Atualizacao realizada'));
  }

  alteraStatus(cpf: string, status: string) {

    // variável da url
    const url2 = `${environment.bancoInscrito}/AlterarStatus?cpf=${cpf}&status=${status}`;
    // consulta a API
    console.log(' MMMMMM = ',url2);
    return this.http.post<any>(url2, {}).subscribe(resposta => console.log('alteração realizado'));

  }


  enviaEmail(remetente: string, destino: string, titulo: string, mens: string){

    return this.http.get<any>(`${environment.bancoInscrito}/EnviarEmail?remetente=${remetente}&destino=${destino}&titulo=${destino}&mens=${mens}`).toPromise();




  }

  validarCPF(inputCPF: string) {

    if (!inputCPF) {
      return false;
    }

    let soma = 0;
    let resto;
    // var inputCPF = document.getElementById('cpf').value;

    if (inputCPF === '00000000000') { return false; }
    if (inputCPF === '99999999999') { return false; }
    // tslint:disable-next-line: radix
    for (let i = 1; i <= 9; i++) { soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i); }
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) { resto = 0; }
    // tslint:disable-next-line: radix
    if (resto !== parseInt(inputCPF.substring(9, 10))) { return false; }

    soma = 0;
    // tslint:disable-next-line: radix
    for (let i = 1; i <= 10; i++) { soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i); }
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) { resto = 0; }
    // tslint:disable-next-line: radix
    if (resto !== parseInt(inputCPF.substring(10, 11))) { return false; }
    return true;
  }

  EnviarEmailConf(remetente: string, destino: string, titulo: string, mens: string) {
    //this.remetente  = "jpacheco@inca.gov.br";
    //this.titulo = "Solicitacao de Veiculos";
    // const params = new HttpParams();
    // params.append('remetente', remetente);
    // params.append('destino', destino);
    // params.append('titulo', titulo);
    // params.append('mens', mens);
    // return this.http.get<any>(`${environment.bancoSolicitacao}/EnviarEmailConfirmacao?remetente=`+remetente+`&destino=`+destino+`&titulo=`+titulo+`&mens=`+mens);
  }



  DeletarArquivo(cpf: string, tipo: string) {

    // variável da url
    const url2 = `${environment.bancoUpload}/ExcluirArquivo?cpf=${cpf}&tipo=${tipo}`
    // consulta a API
    return this.http.post<any>(url2, {});
  }

  ExisteArquivo(cpf: string, tipo: string) {

    // variável da url
    const url2 = `${environment.bancoUpload}/ExisteArquivo?cpf=${cpf}&tipo=${tipo}`
    // consulta a API
    return this.http.get<any>(url2, {});
  }





  testePdf(arquivo: string) {

    // variável da url
    const url2 = `${environment.bancoDocumentos}/${arquivo}`

    console.log(url2);
  }

}
